import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable, Subscriber } from 'rxjs';
import { environment } from '../../environments/environment';
import { subscribeOn } from 'rxjs/operators';

@Injectable()
export class WebSocketService {
  
  socket;
  currentUser = JSON.parse(localStorage.getItem("currentUser"));
  constructor() {
    this.socket = io(environment.SOCKET_ENDPOINT);
    var token = this.currentUser.token.accessToken;
    this.socket.emit('authenticate', { token }); 
    this.socket.on("authenticate", function (data:any) {
      // console.log('data authenticate', data);
    });
  }

  listen(eventName:string){
    return new Observable((Subscriber) => {
      this.socket.on(eventName, (data:any) => {
        Subscriber.next(data);
      })
    });
  }

  emit(eventName:string, data:any){
    this.socket.emit(eventName, data);    
  }

}